import { TrackingCategory } from '@ps/web-shared-analytics';
import type { TrackingContextValue } from '@ps/web-shared-analytics';

import type { RewardsStateModel } from '@swf/core/types/RewardsLegacy';

import { GAEvent } from './utils';

// @TODO dimensions for boost and tier-up
export const rewardsImpression = (tracking: TrackingContextValue, data: RewardsStateModel) => {
  GAEvent({ action: 'Progress Seen' }, { category: TrackingCategory.Rewards });
};
